var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthImgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 132,
    viewBox: "0 0 133 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18131,
    cy: 2.32257,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18143,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18143,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18143,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18143,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18143,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18143,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18143,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 2.3227,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.703,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 2.3227,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4424,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 2.3227,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2683,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 2.3227,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.79,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 2.3227,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5292,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 2.3227,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3554,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 2.3227,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 75.0966,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 38.7095,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 111.484,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 20.5159,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 93.2901,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 56.9034,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6162,
    cy: 129.677,
    rx: 2.18131,
    ry: 2.32257,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthImgRight);
export default __webpack_public_path__ + "static/media/auth-img-right.b3a0185faa0fefb7e03db5082eb244cc.svg";
export { ForwardRef as ReactComponent };